import React, { useState, useEffect, useRef } from "react";
import axios from 'axios';

export default function AccountInfo({ data }) {
    const [profileMenuOpen, setProfileMenuOpen] = useState(false);
    const [showLogoutButton, setShowLogoutButton] = useState(false);
    const menuRef = useRef(null);
    useEffect(() => {
        const handleOutsideClick = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target) && !document.getElementById("profile_icon").contains(event.target)) {
                setProfileMenuOpen(false); // Close the menu if clicked outside
            }
        };

        if (profileMenuOpen) {
            document.addEventListener('mousedown', handleOutsideClick);
        } else {
            document.removeEventListener('mousedown', handleOutsideClick);
        }
        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, [profileMenuOpen]);
    const toggleProfileMenu = () => setProfileMenuOpen(!profileMenuOpen);

    const handleLogout = async () => {
        setShowLogoutButton(true);
        try {
            const response = await axios.post(`${process.env.REACT_APP_ACCOUNT_API_URL}/logout`, {}, { withCredentials: true });
            if (response.data.success) {
                window.location.reload();
            }
        } catch (error) {
            alert(error);
        } finally {
            setShowLogoutButton(false);
        }
    }
    const loginbtn = () => {
        const redirect = window.location;
        window.location = process.env.REACT_APP_ACCOUNT_APP_URL + "/signup?redirect=" + redirect
    }

    return (
        <div>
            {!data ? (<div className='w-16 h-8 relative rounded-md overflow-hidden'><div className='skeleton'></div></div>) : (
                (data.auth ? (
                    <>
                        <div
                            onClick={toggleProfileMenu} id={'profile_icon'}
                            className="cursor-pointer font-bold w-10 h-10 bg-blue-200 text-blue-600 flex items-center justify-center rounded-full overflow-hidden"
                        >
                            {(data && data.auth) ? (
                                <img alt='profile-photo' className="" src={process.env.REACT_APP_API_URL + `/proxy-image?url=${encodeURIComponent(data.user.pp)}`} />
                            ) : (<div></div>)}
                        </div>

                        {profileMenuOpen && (
                            data ? (
                                <><div ref={menuRef}
                                    className="absolute top-0 mt-12 right-0 w-50 bg-white py-2 shadow-md border border-gray-100 rounded-lg z-40"                                        >
                                    <div class="flex flex-col px-4 py-2 space-y-1 font-medium border-b">
                                        <span class="text-gray-800">{data.user.name}</span>
                                        <span class="text-sm text-gray-400 text-ellipsis overflow-hidden">{data.user.email}</span>
                                    </div>
                                    <div class="flex items-center justify-center py-2 font-semibold text-black-700 border-t">
                                        <button className="cursor-pointer" onClick={handleLogout}>{showLogoutButton ? (<>
                                            <div className="flex items-center">
                                                <div class="w-3 h-3 rounded-full animate-spin 
border-2 border-solid border-black border-t-transparent mr-2"></div>
                                                Logging out</div>
                                        </>) : (<>
                                            Logout
                                        </>)}</button>
                                    </div>
                                </div></>
                            ) : (<div className='skeleton'></div>)
                        )}</>) : (<><button onClick={loginbtn} class="cursor-pointer inline-flex items-center px-3 py-2 bg-gray-200 hover:bg-gray-300 text-gray-800 text-sm font-medium rounded-md">
                            <svg class="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M15 16.5V19C15 20.1046 14.1046 21 13 21H6C4.89543 21 4 20.1046 4 19V5C4 3.89543 4.89543 3 6 3H13C14.1046 3 15 3.89543 15 5V8.0625M20 12L9 12M9 12L11.5 14.5M9 12L11.5 9.5" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            Login
                        </button></>)
                )
            )}
        </div>
    )
}
